import API from "../services";
import SETTINGS from "../config";
import Actions from "../actions/Creators";
import user from "./UserSaga";
import orders from "./OrdersSaga";
import dashboard from "./DashboardSaga";
import products from "./ProductsSaga";
import statements from "./StatementsSaga";
import transfer from "./TransferSaga";
import reports from "./ReportsSaga";
import disputes from "./DisputesSaga";

import imports from "./ImportSaga";
import inventory from "./InventorySaga";
import stockRequest from "./StockRequestSaga";

import { fork, put, all } from "redux-saga/effects";

function* getApi() {
  const api = yield API.create();
  return api;
}

export default function* root() {
  const api = yield getApi();

  // Let's create some API contextualized watchers.
  const userWatchers = user(api);
  const dashboardWatcher = dashboard(api);
  const ordersWatcher = orders(api);
  const productsWatcher = products(api);
  const statementsWatcher = statements(api);
  const transferWatcher = transfer(api);
  const reportsWatcher = reports(api);

  const importsWatcher = imports(api);
  const inventoryWatcher = inventory(api);
  const stockRequestWatcher = stockRequest(api);
  const disputesWatcher = disputes(api);

  yield all([
    fork(importsWatcher.watchGetImportAsnBatches),
    fork(importsWatcher.watchGetStockAsnBatches),
    fork(importsWatcher.watchGetImportLines),
    fork(importsWatcher.watchGetStockLines),
    fork(importsWatcher.watchExportStock),
    fork(importsWatcher.watchImportStock),

    fork(userWatchers.watchGetUser),
    fork(userWatchers.watchGetOfferCount),
    fork(userWatchers.watchSyncInventory),
    fork(userWatchers.watchGetNotification),
    fork(userWatchers.watchReadNotification),
    fork(userWatchers.watchGetTnC),
    fork(userWatchers.watchGetSeller),
    fork(userWatchers.watchLogout),
    fork(userWatchers.watchGetVatInfo),
    fork(userWatchers.watchAcceptTerms),
    fork(userWatchers.watchGetWareHouses),
    fork(userWatchers.watchGetUsersList),
    fork(userWatchers.watchGetNotificationPreference),
    fork(userWatchers.watchPostPreference),
    fork(userWatchers.watchGetFbnSettings),
    fork(userWatchers.watchChangeFbnSettings),

    fork(dashboardWatcher.watchGetDashboard),

    fork(ordersWatcher.watchgetOrdersV2),
    fork(ordersWatcher.watchpostOrdersV2),
    fork(ordersWatcher.watchpostPickupV2),
    fork(ordersWatcher.watchPrintOrder),

    fork(productsWatcher.watchGetProducts),
    fork(productsWatcher.watchGetProductCount),
    fork(productsWatcher.watchSearchProducts),
    fork(productsWatcher.watchPostProducts),
    fork(productsWatcher.watchExportOffers),
    fork(productsWatcher.watchExportPSku),
    fork(productsWatcher.watchActivateOffers),
    fork(productsWatcher.watchDeleteOffers),
    fork(productsWatcher.watchImportOffers),

    fork(productsWatcher.watchImportPSkuUnique),

    fork(statementsWatcher.watchGetInvoices),
    fork(statementsWatcher.watchGetInvoicesNoon),
    fork(statementsWatcher.watchGetCreditNotes),
    fork(statementsWatcher.watchGetPayments),
    fork(statementsWatcher.watchGetFinanceView),
    fork(statementsWatcher.watchGetOrderView),
    fork(statementsWatcher.watchExportCreditNote),
    fork(statementsWatcher.watchExportInvoice),
    fork(statementsWatcher.watchExportStatements),
    fork(statementsWatcher.watchGetPaymentDetails),

    fork(transferWatcher.watchPostOutbound),
    fork(transferWatcher.watchGetTransfers),
    fork(transferWatcher.watchGetAsn),
    fork(transferWatcher.watchImportFbnAsn),
    fork(transferWatcher.watchgetTransfersCount),
    fork(transferWatcher.watchgetFbnTransfersCount),
    fork(transferWatcher.watchCloseAsn),
    fork(transferWatcher.watchOpenFbnAsn),
    fork(transferWatcher.watchGetInitialLines),
    fork(transferWatcher.watchGetProcessedLines),
    fork(transferWatcher.watchScheduleAsn),
    fork(transferWatcher.watchExportEligibleOffers),
    fork(transferWatcher.watchGetAsnBatches),
    fork(transferWatcher.watchRetrieveSlots),
    fork(transferWatcher.watchGetStatus),
    fork(transferWatcher.watchGetRtvStatuses),

    fork(reportsWatcher.watchGetReports),
    fork(reportsWatcher.watchExportReports),
    fork(reportsWatcher.watchGetSales),
    fork(reportsWatcher.watchGetSalesItemDetails),
    fork(reportsWatcher.watchGetSalesStatus),

    fork(ordersWatcher.watchGetOrders),
    fork(ordersWatcher.watchPostOrders),
    fork(ordersWatcher.watchGetReservedOrders),
    fork(ordersWatcher.watchGetOrderCount),
    fork(ordersWatcher.watchgetSingleOrder),
    fork(ordersWatcher.watchOpenPickup),

    fork(inventoryWatcher.watchGetInventoryStock),
    fork(inventoryWatcher.watchGetInventoryWarehouse),

    fork(stockRequestWatcher.watchGetRequests),
    fork(stockRequestWatcher.watchCreatePicklist),
    fork(stockRequestWatcher.watchGetPicklists),
    fork(stockRequestWatcher.watchGetPicklistItems),
    fork(stockRequestWatcher.watchMarkReadyForPickup),
    fork(stockRequestWatcher.watchGetReadyForPickup),
    fork(stockRequestWatcher.watchUpdatePicklistQty),
    fork(stockRequestWatcher.watchGetStocksCount),
    fork(stockRequestWatcher.watchMarkOutOfStock),

    fork(disputesWatcher.watchSearchDisputeAsnRtv),
    fork(disputesWatcher.watchCreateDispute),
    fork(disputesWatcher.watchListDisputes),
    fork(disputesWatcher.watchListDisputeReasons)
  ]);

  yield put(Actions.getUser());
}



// WEBPACK FOOTER //
// ./src/sagas/index.js